module.exports = __webpack_public_path__ + "static/media/md-notifications.bab1701f.svg";